// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-pagination {\n  background: transparent;\n  color: #fff;\n}\n.select-pagination button {\n  background: transparent;\n}\n.select-pagination .el-pager li {\n  background: transparent;\n}\n.select-pagination .btn-next, .select-pagination .btn-prev {\n  background: transparent !important;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
